import { Input } from '@salecycle/ui-component-library';
import * as React from 'react';
import { connect } from 'react-redux';

import { ActiveBasketValueIsLessThan } from 'entities/campaign/rules';
import { Actions } from 'sections/campaigns/state/rulesets';
import { OwnProps, Props } from './props';

export type FormProps = Props<ActiveBasketValueIsLessThan>;

export const Form: React.FC<FormProps> = (props: FormProps) => {
  const onChange = (value: string) =>
    props.update(props.rulesetId, props.ruleIndex, {
      maxValue: Number(value),
    });

  return (
    <div data-testid="ActiveBasketValueIsLessThan">
      <Input
        label="Total value (USD) of the basket is less than"
        ariaLabel="Total value (USD) of the basket is less than"
        inputId="ValueInput"
        type="number"
        onChange={onChange}
        value={props.rule.maxValue ?? 0}
      />
    </div>
  );
};

export default connect<{}, {}, OwnProps>(null, { update: Actions.editRule })(Form);
